import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";

import { MantineProvider } from "@mantine/core";
import React, { ReactNode } from "react";

import { Layout } from "@containers";

import { HeaderConfig } from "@types";

import { theme } from "./src/theme";

import "./src/styles/global.css";

export const wrapPageElement = ({ element }: { element: ReactNode }) => {
  // Extract header config from the page component if it exists
  let headerConfig: HeaderConfig = {};

  if (React.isValidElement(element)) {
    const pageComponent = element.type as any;
    if (pageComponent?.headerConfig) {
      headerConfig = pageComponent.headerConfig;
    }
  }

  return (
    <MantineProvider
      theme={theme}
      defaultColorScheme="light"
      forceColorScheme="light"
    >
      <Layout headerConfig={headerConfig}>{element}</Layout>
    </MantineProvider>
  );
};
